import React, { useEffect, useState, useRef, useContext } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useTheme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { loadModules } from 'esri-loader';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Cookies from 'js-cookie';

import '../../scss/components/_lane_geometry.scss';
import API_PATH from "../../constants/config.json";
import TurnPhasing from './LaneConfig/TurnPhasing';
import Parking from './LaneConfig/Parking';
import LanesButtons from './LaneConfig/LanesButtons';
import MapContext from '../../context/MapContext';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const EditLaneGeometrySwitch = withStyles((theme) => ({
    root: {
        width: 44,
        height: 24,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#2563EB',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#2563EB',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 22,
        height: 22,
    },
    track: {
        borderRadius: 24,
        border: `1px solid #E4E4E7`,
        backgroundColor: '#E4E4E7',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {}
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const LaneGeometry = props => {

    let view = null;
    // let typeControl = 'Signal';
    const theme = useTheme();
    const mapRef = useRef();
    const [home, setHome] = React.useState(null);
    const [zoom, setZoom] = React.useState(null);
    const [typeControl, setTypeControl] = useState('Signal');

    // lane config
    const [nbLanes, setNbLanes] = useState([]);
    const [sbLanes, setSbLanes] = useState([]);
    const [ebLanes, setEbLanes] = useState([]);
    const [wbLanes, setWbLanes] = useState([]);

    const [maxLanes, setMaxLanes] = useState(false);
    const [lanesConflict, setLanesConflict] = useState(false);
    // street names
    const [nbApproach, setNbApproach] = useState(null);
    const [sbApproach, setSbApproach] = useState(null);
    const [ebApproach, setEbApproach] = useState(null);
    const [wbApproach, setWbApproach] = useState(null);
    // parking 
    const [nbParking, setNbParking] = useState(false);
    const [sbParking, setSbParking] = useState(false);
    const [ebParking, setEbParking] = useState(false);
    const [wbParking, setWbParking] = useState(false);
    // phasing
    const [nbRTPhasing, setNbRTPhasing] = useState("");
    const [nbLTPhasing, setNbLTPhasing] = useState("");
    const [sbRTPhasing, setSbRTPhasing] = useState("");
    const [sbLTPhasing, setSbLTPhasing] = useState("");
    const [ebRTPhasing, setEbRTPhasing] = useState("");
    const [ebLTPhasing, setEbLTPhasing] = useState("");
    const [wbRTPhasing, setWbRTPhasing] = useState("");
    const [wbLTPhasing, setWbLTPhasing] = useState("");

    const [phasingList, setPhasingList] = useState([]);

    const [initialConfig, setInitialConfig] = useState([]);

    const { updateStationDetails } = useContext(MapContext);

    const ltmovs = [1, 3, 4, 5, 6, 7];

    // edit lane geometry
    const [switchLaneGeometry, setSwitchLaneGeometry] = useState(false);
    const [showWarningLaneGeometryEdit, setShowWarningLaneGeometryEdit] = useState(false);
    const [editLaneGeometry, setEditLaneGeometry] = useState(false);

    useEffect(() => {
        getSignalPhasingData();
        loadMap("streets-navigation-vector", props.lat, props.long, props.stationType);
    }, [])

    useEffect(() => {
        if (props.approachesForLane && props.approachesForLane.length > 0) {
            let approaches = props.approachesForLane;
            approaches.forEach(function (item, ind) {
                if (item.eb_approach) {
                    setEbApproach(item.eb_approach);
                } else if (item.wb_approach) {
                    setWbApproach(item.wb_approach);
                } else if (item.nb_approach) {
                    setNbApproach(item.nb_approach);
                } else if (item.sb_approach) {
                    setSbApproach(item.sb_approach);
                }
            });
        }
    }, [props.approachesForLane]);

    useEffect(()=>{
        if (props.laneConfigId) {
            getLaneGeometryData();
        }
    },[props.laneConfigId])

    const loadMap = (basemap = 'streets-navigation-vector', lat, lng, station_type) => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic",
            "esri/widgets/BasemapToggle", "esri/Basemap"], { css: true })
            .then(([Map, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, BasemapToggle, Basemap]) => {

                let _basemap = new Basemap({
                    portalItem: {
                        id: "86265e5a4bbb4187a59719cf134e0018"  // Imagery Hybrid
                    }
                });
                let previusBaseMap = _basemap;

                const map = new Map({
                    basemap,
                    slider: false
                });

                view = new MapView({
                    container: mapRef.current,
                    map: map,
                    // isPan: true,
                    // center: [-106.61, 35.1107],
                    zoom: 20,
                    ui: {
                        components: ['home', 'locate'] // specify only the components you want
                    },
                });
                // let mapTypePrev = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') === 'hybrid' ? 'arcgis-imagery' : 'arcgis-dark-gray';
                var basemapToggle = new BasemapToggle({
                    view: view,  // The view that provides access to the map's "streets-vector" basemap
                    nextBasemap: previusBaseMap  // Allows for toggling to the "hybrid" basemap
                });

                view.ui.add(basemapToggle, "bottom-left");

                // setTempMapView(view)
                let featureLayer = new FeatureLayer({
                    url: sessionStorage.getItem('mapURL')
                });
                map.add(featureLayer);
                featureLayer.when(function () { // adds feature layer to map view
                    view.extent = featureLayer.fullExtent;
                    let point = new Point(lng, lat);
                    let pointSymbol = {
                        type: "simple-marker",
                        style: "circle",
                        color: "#00b15e",
                        size: 20,
                        outline: {
                            color: "#3676bc",
                            width: 0.5
                        }
                    }
                    let symbolInt = {
                        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                        url: require("../../assets/icons/marker_Intersection.png"),
                        width: "42px",
                        height: "42px",
                        yoffset: "20px"
                    };
                    let symbolMid = {
                        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                        url: require("../../assets/icons/marker_Midblock.png"),
                        width: "42px",
                        height: "42px",
                        yoffset: "20px"
                    };
                    if (station_type == 1) {
                        pointSymbol = symbolMid;
                    } else {
                        pointSymbol = symbolInt;
                    }
                    let pointGraphic = new Graphic(point, pointSymbol);
                    view.graphics.add(pointGraphic);
                    view.goTo(pointGraphic).then(function () {
                        view.zoom = view.zoom + 5;
                    });

                    let vp = new Viewpoint({
                        targetGeometry: point
                    });
                    homeButton.viewpoint = vp;
                });

                let homeButton = new Home({
                    view: view,
                });
                let zoom = new Zoom({
                    view: view,
                });
                setHome(homeButton)
                setZoom(zoom)

            });
    }

    const homeEvent = () => { // event to go at initial view
        home.go();
        home.on("go", function (event) {
        })
    }
    const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();

    }
    const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();

    }

    const getSignalPhasingData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.signalPhasingList,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setPhasingList(response.data.data);
                    }
                    else {
                        setPhasingList([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getLaneGeometryData = () => {
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload')
                },
                data: {
                    lane_id: props.laneConfigId
                },
                url: API_URL + API_PATH.getLaneGeometry,
            })
                .then(async function (response) {
                    if (response.status && response.status == 200) {
                        if (response.data && response.data.data) {
                            let data = response.data.data;
                            setInitialConfig(data);

                            resetDiagram(data);
                        }
                    }
                })
                .catch(function (error) {
                })
        } catch (error) {
        }
    }

    const handleTypeControl = (e) => {
        let value = e.target.value;
        setTypeControl(value);
        if (value !== 'Signal') {
            setNbRTPhasing("");
            setNbLTPhasing("");
            setSbRTPhasing("");
            setSbLTPhasing("");
            setEbRTPhasing("");
            setEbLTPhasing("");
            setWbRTPhasing("");
            setWbLTPhasing("");
            if (value === "Roundabout") {
                // for roundabouts, the left turn lane (L) is disallowed
                [nbLanes, sbLanes, ebLanes, wbLanes].forEach(function (arr, inArr) {
                    while (arr.includes(4)) {
                        let pos = arr.indexOf(4);
                        arr.splice(pos, 1);
                    }
                    switch (inArr) {
                        case 0:
                            setNbLanes(arr);
                            break;
                        case 1:
                            setSbLanes(arr);
                            break;
                        case 2:
                            setEbLanes(arr);
                            break;
                        case 3:
                            setWbLanes(arr);
                            break;
                    }
                });
            }
        }
    }

    const handleSetLane = (mov, dir) => {
        mov = parseInt(mov);

        // validation for phasing in opposite approaches
        if (ltmovs.includes(mov)) {
            phasingValidation(mov, dir);
        }

        setMaxLanes(false);
        setLanesConflict(false);
        // getting the arrays based on the approach
        let collection = getArrayToWorkWith(dir);
        // validate number of elements in the array
        if (collection.length === 7) {
            setMaxLanes(true);
            return;
        }

        // validate conflict movements
        let validMovs = validateMovements(collection, mov);
        if (validMovs) {
            collection.push(mov);
            let newcoll = sortMovements(collection);
            fnSetNewArray(newcoll, dir);
        }
    }

    const getArrayToWorkWith = (dir) => {
        let collection = null;
        switch (dir) {
            case 'nb':
                collection = [...nbLanes];
                break;
            case 'sb':
                collection = [...sbLanes];
                break;
            case 'eb':
                collection = [...ebLanes];
                break;
            case 'wb':
                collection = [...wbLanes];
                break;
        }
        return collection;
    }

    const validateMovements = (collection, newmov) => {
        let valid = true;
        switch (newmov) {
            case 8:
                if (collection.includes(8))
                    valid = false;
                break;
            case 7:
                if (collection.includes(2) || collection.includes(3) || collection.includes(5) || collection.includes(6) || collection.includes(7))
                    valid = false;
                break;
            case 6:
                if (collection.includes(5) || collection.includes(7) || collection.includes(6))
                    valid = false;
                break;
            case 5:
                if (collection.includes(2) || collection.includes(3) || collection.includes(6) || collection.includes(7) || collection.includes(5))
                    valid = false;
                break;
            case 4:
                if (typeControl === "Roundabout")
                    valid = false;
                break;
            case 3:
                if (collection.includes(3) || collection.includes(5) || collection.includes(7))
                    valid = false;
                break;
            case 2:
                if (collection.includes(7) || collection.includes(5))
                    valid = false;
                break;
        }

        if (!valid) {
            setLanesConflict(true);
        }

        return valid;

    }

    const sortMovements = (collection) => {
        collection.sort();
        // sort special movements
        let pos = null;
        collection.forEach((v, i) => {
            if (v == 2) {
                pos = getPos(collection, 3, 'eq');
                if (pos >= 0 && i < pos) {
                    collection = setSpecialMovement(collection, i, pos, 2);
                }
            }
            if (v == 3) {
                pos = getPos(collection, 2, '');
                collection = setSpecialMovement(collection, i, pos, 3);
            }
            if (v == 5) {
                pos = getPos(collection, 4, '');
                collection = setSpecialMovement(collection, i, pos, 5);
            }
            if (v == 6) {
                pos = getPos(collection, 4, '');
                collection = setSpecialMovement(collection, i, pos, 6);
            }
            if (v == 7) {
                pos = getPos(collection, 4, '');
                collection = setSpecialMovement(collection, i, pos, 7);
            }
        });

        var pos3 = getPos(collection, 3, 'eq');
        if (pos3 >= 0) {
            pos = getPos(collection, 2, '');
            collection = setSpecialMovement(collection, pos3, pos, 3);
        }

        return collection;
    }

    const getPos = (collection, value, cond) => {
        // return the position of the element to look for
        const isLargerNum = cond == '' ? (el) => el >= value : (el) => el == value;
        const ind = collection.findIndex(isLargerNum);
        return ind;
    }

    const setSpecialMovement = (collection, i, pos, mov) => {
        if (pos && pos < 0) {
            // if the element to add before to does not exist, add it at the end of the array
            collection.splice(i, 1);
            collection[collection.length] = mov;
        } else if (pos >= 0) {
            // if the element to add before to exists, add it at the specific position
            collection.splice(i, 1);
            collection.splice(pos, 0, mov);
        }

        return collection;
    }

    const fnSetNewArray = (collection, dir) => {
        switch (dir) {
            case 'nb':
                setNbLanes(collection);
                break;
            case 'sb':
                setSbLanes(collection);
                break;
            case 'eb':
                setEbLanes(collection);
                break;
            case 'wb':
                setWbLanes(collection);
                break;
        }
    }

    const phasingValidation = (mov, dir) => {
        switch (dir) {
            case 'nb':
                if ((mov === 4 || mov === 5 || mov === 6 || mov === 7) && sbLTPhasing)
                    setNbLTPhasing(sbLTPhasing);
                else if ((mov === 1 || mov === 3 || mov === 5 || mov === 7) && sbRTPhasing)
                    setNbRTPhasing(sbRTPhasing);
                break;
            case 'sb':
                if ((mov === 4 || mov === 5 || mov === 6 || mov === 7) && nbLTPhasing)
                    setSbLTPhasing(nbLTPhasing);
                else if ((mov === 1 || mov === 3 || mov === 5 || mov === 7) && nbRTPhasing)
                    setSbRTPhasing(nbRTPhasing);
                break;
            case 'eb':
                if ((mov === 4 || mov === 5 || mov === 6 || mov === 7) && wbLTPhasing)
                    setEbLTPhasing(wbLTPhasing);
                else if ((mov === 1 || mov === 3 || mov === 5 || mov === 7) && wbRTPhasing)
                    setEbRTPhasing(wbRTPhasing);
                break;
            case 'wb':
                if ((mov === 4 || mov === 5 || mov === 6 || mov === 7) && ebLTPhasing)
                    setWbLTPhasing(ebLTPhasing);
                else if ((mov === 1 || mov === 3 || mov === 5 || mov === 7) && ebRTPhasing)
                    setWbRTPhasing(ebRTPhasing);
                break;
        }
    }

    const removeFromLanes = (img, dir) => {
        setMaxLanes(false);
        setLanesConflict(false);
        let arr = [];
        let pos = null;
        switch (dir) {
            case 'nb':
                arr = [...nbLanes];
                pos = arr.indexOf(img);
                if (pos >= 0) {
                    arr.splice(pos, 1);
                }
                setNbLanes(arr);
                break;
            case 'sb':
                arr = [...sbLanes];
                pos = arr.indexOf(img);
                if (pos >= 0) {
                    arr.splice(pos, 1);
                }
                setSbLanes(arr);
                break;
            case 'eb':
                arr = [...ebLanes];
                pos = arr.indexOf(img);
                if (pos >= 0) {
                    arr.splice(pos, 1);
                }
                setEbLanes(arr);
                
                break;
            case 'wb':
                arr = [...wbLanes];
                pos = arr.indexOf(img);
                if (pos >= 0) {
                    arr.splice(pos, 1);
                }
                setWbLanes(arr);
                break;
        }
        // disabled and clear dropdown phasing
        phasingDropdownValidation(img, arr, dir);
    }

    const phasingDropdownValidation = (img, arr, dir) => {
        if ( (img === 1 && !arr.includes(1)) || (img === 3 && !arr.includes(3)) || (img === 5 && !arr.includes(5)) || (img === 7 && !arr.includes(7)) ) {
           dir === "nb" ? setNbRTPhasing("") : (dir === "sb" ? setSbRTPhasing("") : (dir === "eb" ? setEbRTPhasing("") : setWbRTPhasing("")));
            if(!arr.includes(4) && !arr.includes(6)) {
                dir === "nb" ? setNbLTPhasing("") : (dir === "sb" ? setSbLTPhasing("") : (dir === "eb" ? setEbLTPhasing("") : setWbLTPhasing("")));    
            }
        }
        else if ( (img === 4 && !arr.includes(4)) || (img === 5 && !arr.includes(5)) || (img === 6 && !arr.includes(6)) || (img === 7 && !arr.includes(7)) ){
            dir === "nb" ? setNbLTPhasing("") : (dir === "sb" ? setSbLTPhasing("") : (dir === "eb" ? setEbLTPhasing("") : setWbLTPhasing("")));
            if(!arr.includes(1) && !arr.includes(3)) {
                dir === "nb" ? setNbRTPhasing("") : (dir === "sb" ? setSbRTPhasing("") : (dir === "eb" ? setEbRTPhasing("") : setWbRTPhasing("")));
            }
        }
    }

    const handleSetParking = (checked, dir) => {
        switch (dir) {
            case 'nb':
                setNbParking(checked);
                break;
            case 'sb':
                setSbParking(checked);
                break;
            case 'eb':
                setEbParking(checked);
                break;
            case 'wb':
                setWbParking(checked);
                break;
        }
    }

    const handleSetPhasing = (value, dir, lr) => {
        switch (dir) {
            case 'nb':
                lr === "left" ? setNbLTPhasing(value) : setNbRTPhasing(value);
                // if ((sbLanes.includes(4) || sbLanes.includes(5) || sbLanes.includes(6) || sbLanes.includes(7)) && lr === 'left') {
                //     setSbLTPhasing(value);
                // } else if ((sbLanes.includes(1) || sbLanes.includes(3) || sbLanes.includes(5) || sbLanes.includes(7)) && lr === 'right') {
                //     setSbRTPhasing(value);
                // }
                break;
            case 'sb':
                lr === "left" ? setSbLTPhasing(value) : setSbRTPhasing(value);
                // if ((nbLanes.includes(4) || nbLanes.includes(5) || nbLanes.includes(6) || nbLanes.includes(7)) && lr === 'left') {
                //     setNbLTPhasing(value);
                // } else if ((nbLanes.includes(1) || nbLanes.includes(3) || nbLanes.includes(5) || nbLanes.includes(7)) && lr === 'right') {
                //     setNbRTPhasing(value);
                // }
                break;
            case 'eb':
                lr === "left" ? setEbLTPhasing(value) : setEbRTPhasing(value);
                // if ((wbLanes.includes(4) || wbLanes.includes(5) || wbLanes.includes(6) || wbLanes.includes(7)) && lr === 'left') {
                //     setWbLTPhasing(value);
                // } else if ((wbLanes.includes(1) || wbLanes.includes(3) || wbLanes.includes(5) || wbLanes.includes(7)) && lr === 'right') {
                //     setWbRTPhasing(value);
                // }
                break;
            case 'wb':
                lr === "left" ? setWbLTPhasing(value) : setWbRTPhasing(value);
                // if ((ebLanes.includes(4) || ebLanes.includes(5) || ebLanes.includes(6) || ebLanes.includes(7)) && lr === 'left') {
                //     setEbLTPhasing(value);
                // } else if ((ebLanes.includes(1) || ebLanes.includes(3) || ebLanes.includes(5) || ebLanes.includes(7)) && lr === 'right') {
                //     setEbRTPhasing(value);
                // }
                break;
        }
    }

    const handleClearLaneConfig = () => {
        if (!props.stationId && !props.laneConfigId) {
            let data = {
                control_type: "Signal",
                nb_lanes: [],
                sb_lanes: [],
                eb_lanes: [],
                wb_lanes: [],
                nb_parking: false,
                sb_parking: false,
                eb_parking: false,
                wb_parking: false,
                nb_right_turn_phasing: "",
                nb_left_turn_phasing: "",
                sb_right_turn_phasing: "",
                sb_left_turn_phasing: "",
                eb_right_turn_phasing: "",
                eb_left_turn_phasing: "",
                wb_right_turn_phasing: "",
                wb_left_turn_phasing: ""
            }
            setNbLanes([]);
            setSbLanes([]);
            setEbLanes([]);
            setWbLanes([]);
            resetDiagram(data);
        } else {
            resetDiagram();
        }

    }

    const resetDiagram = (data = null) => {
        if (!data) {
            data = initialConfig;
        }
        // setting type of control
        setTypeControl(data.control_type);
        if (data.stop_controlled && data.stop_controlled !== 'None') {
            setTypeControl(data.control_type + "-" + data.stop_controlled);
        }
        // setting lanes
        const regex = /0/ig;
        [data.nb_laneconfig, data.sb_laneconfig, data.eb_laneconfig, data.wb_laneconfig].forEach(function (arr, ind) {
            if (arr) {
                let tmp = arr.replaceAll(regex, '');
                let tmpArr = [];
                for (let i = 0; i < tmp.length; i++) {
                    tmpArr.push(parseInt(tmp[i]));
                }
                ind == 0 ? setNbLanes(tmpArr) : ind === 1 ? setSbLanes(tmpArr) : ind === 2 ? setEbLanes(tmpArr) : setWbLanes(tmpArr);
            }
        });

        // setting parking
        setNbParking(data.nb_parking);
        setSbParking(data.sb_parking);
        setEbParking(data.eb_parking);
        setWbParking(data.wb_parking);
        // setting phasing
        setNbRTPhasing(data.nb_right_turn_phasing >= 0 ? data.nb_right_turn_phasing : "");
        setNbLTPhasing(data.nb_left_turn_phasing >= 0 ? data.nb_left_turn_phasing : "");
        setSbRTPhasing(data.sb_right_turn_phasing >= 0 ? data.sb_right_turn_phasing : "");
        setSbLTPhasing(data.sb_left_turn_phasing >= 0 ? data.sb_left_turn_phasing : "");
        setEbRTPhasing(data.eb_right_turn_phasing >= 0 ? data.eb_right_turn_phasing : "");
        setEbLTPhasing(data.eb_left_turn_phasing >= 0 ? data.eb_left_turn_phasing : "");
        setWbRTPhasing(data.wb_right_turn_phasing >= 0 ? data.wb_right_turn_phasing : "");
        setWbLTPhasing(data.wb_left_turn_phasing >= 0 ? data.wb_left_turn_phasing : "");
    }

    const handleSaveLaneConfig = (data) => {    
        try {
            axios({
                method: 'post',
                data,
                headers: {
                    'payload': Cookies.get('payload')
                },
                url: props.laneConfigId ? API_URL + API_PATH.editLaneGeometry : API_URL + API_PATH.saveLaneGeometry,
            })
                .then(async function (response) {
                    if (response.status && response.status == 200) {
                        axios({
                            method: 'post',
                            data: {
                                stationIds: [data.station_id]
                            },
                            headers: {
                                'payload': Cookies.get('payload'),
                            },
                            url: API_URL + API_PATH.createGlobalScenario,
                        }).then(async function (response2) {
                            updateStationDetails({
                                FK_lane_config_id: response.data.message,
                                station_id: data.station_id,
                                globalscenarios: response2.data.message
                            });
                            if(props.fromSignal) {
                                props.setReloadScenarios(true);
                            }
                        });
                        if(props.isEditingFromSignalPlanning){
                            if (!props.laneConfigId){
                                props._setLaneConfigId(response.data.message);
                                props.setShowLaneConfig(false);
                            }
                            props.setReadOnly(true);
                            setEditLaneGeometry(false);
                            setSwitchLaneGeometry(false);
                        }else{
                            updateStationDetails({
                                FK_lane_config_id: response.data.message,
                                station_id: data.station_id
                            });
                            props.setShowLaneConfig(false);
                            if(!props.laneConfigId)
                                props.setLaneConfigId(response.data.message);
                        }
                        if (response.data.message) {
                            //send lane config to update geojson layer            
                            updateStationDetails({
                                FK_lane_config_id: response.data.message,
                                station_id: data.station_id
                            });
                        }

                    }
                })
                .catch(function (error) {
                })
        } catch (error) {
        }
    }

    const handleRemoveLaneConfig = (id) =>{
        try {
            axios({
                method: 'delete',
                headers: {
                    'payload': Cookies.get('payload')
                },
                url: API_URL + API_PATH.deleteLaneGeometry+id,
            })
                .then(async function (response) {
                    if (response.status && response.status == 200) {
                        axios({
                            method: 'post',
                            data: {
                                stationIds: [props.stationId]
                            },
                            headers: {
                                'payload': Cookies.get('payload'),
                            },
                            url: API_URL + API_PATH.createGlobalScenario,
                        }).then(async function (response2) {
                            if(props.fromSignal) {
                                props.setReloadScenarios(true);
                            }
                        });
                        updateStationDetails({
                            FK_lane_config_id: null,
                            station_id: props.stationId
                        });
                        if(props.isEditingFromSignalPlanning){
                            props._setLaneConfigId(null);
                            props.setShowLaneConfig(false);
                            props.setReadOnly(false);
                            setEditLaneGeometry(false);
                            setSwitchLaneGeometry(false);
                        }else{
                            props.setShowLaneConfig(false);
                            props.setLaneConfigId(null);
                        }

                    }
                })
                .catch(function (error) {
                })
        } catch (error) {
        }
    }

    const handleCheckLaneConfig = () =>{
        let config = {};        
        config.nb_parking = nbParking;
        config.sb_parking = sbParking;
        config.eb_parking = ebParking;
        config.wb_parking = wbParking;
        config.nb_right_turn_phasing = nbRTPhasing === "" ? null : parseInt(nbRTPhasing);
        config.nb_left_turn_phasing = nbLTPhasing === "" ? null : parseInt(nbLTPhasing);
        config.sb_right_turn_phasing = sbRTPhasing === "" ? null : parseInt(sbRTPhasing);
        config.sb_left_turn_phasing = sbLTPhasing === "" ? null : parseInt(sbLTPhasing);
        config.eb_right_turn_phasing = ebRTPhasing === "" ? null : parseInt(ebRTPhasing);
        config.eb_left_turn_phasing = ebLTPhasing === "" ? null : parseInt(ebLTPhasing);
        config.wb_right_turn_phasing = wbRTPhasing === "" ? null : parseInt(wbRTPhasing);
        config.wb_left_turn_phasing = wbLTPhasing === "" ? null : parseInt(wbLTPhasing);
        
        //Check if fields are empty
        let propertiesAreEmptys = false;
        let propertiesEmptys = [1,1,1,1,1,1,1,1,1,1,1,1];
        let propertiesIndex = 0;
        for (const [key, value] of Object.entries(config)){
            if (isNaN(value) || value === null || value === undefined || value === false)
                    propertiesEmptys[propertiesIndex] = 0;
            propertiesIndex++;
        }
        let propertiesEmptysSum = 0;
        for (let i = 0 ; i < propertiesEmptys.length ; i++ )
            propertiesEmptysSum += propertiesEmptys[i];
        propertiesAreEmptys = propertiesEmptysSum === 0 ? true : false;
        
        //var for check if lanes are empty
        let lanesAreEmptys = false;
        let laneEmptys = [1,1,1,1]; 

        [nbLanes, sbLanes, ebLanes, wbLanes].forEach(function (arr, ind) {
            //Check if lane is empty
            if(arr.length === 0)
                laneEmptys[ind] = 0;
            //end check
            let collection = [...arr];
            for (let i = arr.length; i < 7; i++) {
                // add a new free position at the end
                collection[i] = 0;
            }
            let tmpColl = collection.join();
            const regex = /,/ig;
            tmpColl = tmpColl.replaceAll(regex, '');
            ind === 0 ? config.nb_laneconfig = tmpColl : ind === 1 ? config.sb_laneconfig = tmpColl : ind === 2 ? config.eb_laneconfig = tmpColl : config.wb_laneconfig = tmpColl;
        });
        
        //Check if lanes are empty
        let lanesEmptysSum = 0;
        for (let i = 0 ; i < laneEmptys.length ; i++ )
            lanesEmptysSum += laneEmptys[i];
        lanesAreEmptys = lanesEmptysSum === 0 ? true : false;

        if (propertiesAreEmptys && lanesAreEmptys){
            handleRemoveLaneConfig(props.laneConfigId);
            return;
        }

        config.stop_controlled = 'None';
        config.control_type = typeControl;
        if (typeControl === 'TWSC-NS') {
            config.stop_controlled = 'NS';
            config.control_type = typeControl.split("-")[0];
        }
        else if (typeControl === 'TWSC-EW') {
            config.stop_controlled = 'EW';
            config.control_type = typeControl.split("-")[0];
        }

        let data = {
            data: config
        };
        if (props.laneConfigId) {
            data.lane_id = props.laneConfigId;
        }
        if (props.stationId) {
            data.station_id = props.stationId;
        }

        handleSaveLaneConfig(data);
    }

    const handleSwitchLaneGeometry = () => {
        setSwitchLaneGeometry(!switchLaneGeometry)
        if (!switchLaneGeometry)
            setShowWarningLaneGeometryEdit(true)
        else{
            setEditLaneGeometry(false);
            props.setReadOnly(true);
        }
    }

    const handleEditLaneGeometry = (e) => {
        setShowWarningLaneGeometryEdit(false)
        if (!e){
            setSwitchLaneGeometry(false);
            setEditLaneGeometry(false);
            return;
        }            
        setSwitchLaneGeometry(true);
        setEditLaneGeometry(true);
        props.setReadOnly(false);
    }

    return (
        <div>
        <Modal
            open={props.showLaneConfig}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={'z_index_test'}
        >
            <div className="lane-main">
                <Container className="lane-container" >
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            <Tab label="Lane geometry" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={'main_panel_title'} />

                        </Tabs>
                        <div className="add-user-cnt">
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowLaneConfig(false)} />
                        </div>
                    </AppBar>
                        {/* Alert */}
                        {
                            (editLaneGeometry) ?
                                <div className="lane-geometry-edit-warning">
                                    <img src={require('../../assets/icons/lane_config/warning.svg')}/>
                                    <label>You are currently editing&nbsp;<b>station lane geometry.</b></label>
                                </div>
                                : null
                        }
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={0}
                        className={'main_bg'}
                    >
                        <TabPanel value={0} index={0} dir={theme.direction}  >                            
                            <div className='config-container'>
                                {/* Map */}
                                <div className='map-container'>
                                    <label>Map</label>
                                    <div>
                                        <div className={'locationMapView'}>
                                            <div ref={mapRef} data-testid='mapView'>
                                                <Box display='flex' flexDirection="column" className='icon-box'>
                                                    <div className={'homeIcon'} title="Home" >
                                                        <img src={require('../../assets/icons/map/Home.png')} onClick={() => homeEvent()} title="Home" />
                                                    </div>
                                                    <div className={'zoomIcon'} style={{ marginBottom: '-3px' }} title="Zoom In">
                                                        <img src={require('../../assets/icons/map/Add.png')} onClick={() => ZoomInEvent()} title="Zoom In" />
                                                    </div>
                                                    <div className={'inIcon'} title="Zoom Out">
                                                        <img src={require('../../assets/icons/map/Minus.png')} onClick={() => zoomOutEvent()} title="Zoom Out" />
                                                    </div>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Control */}
                                <div className='diagram-container'>
                                    {/* Type of control */}
                                    <div className='control-container'>
                                        <label>Type of control:</label>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={typeControl}
                                            name="radio-buttons-group"
                                            onChange={handleTypeControl}
                                        >
                                            <FormControlLabel checked={typeControl === "Signal"} value="Signal" control={<Radio disabled={props.readOnly} />} label="Signal" />
                                            <FormControlLabel checked={typeControl === "AWSC"} value="AWSC" control={<Radio disabled={props.readOnly} />} label="AWSC" />
                                            <FormControlLabel checked={typeControl === "TWSC-NS"} value="TWSC-NS" control={<Radio disabled={props.readOnly} />} label="TWSC-NS" />
                                            <FormControlLabel checked={typeControl === "TWSC-EW"} value="TWSC-EW" control={<Radio disabled={props.readOnly} />} label="TWSC-EW" />
                                            <FormControlLabel checked={typeControl === "Roundabout"} value="Roundabout" control={<Radio disabled={props.readOnly} />} label="Roundabout" />
                                        </RadioGroup>
                                    </div>
                                    {/* switch for edit lane geometry */}
                                    {
                                        (props.isEditingFromSignalPlanning) ? 
                                            <div className='switch-container'>
                                                <FormControlLabel
                                                    control={<EditLaneGeometrySwitch checked={switchLaneGeometry} onChange={(e) => handleSwitchLaneGeometry()} />}
                                                    label={<Typography className={{}}>Edit lane geometry{switchLaneGeometry}</Typography>}
                                                />
                                                {switchLaneGeometry}
                                            </div> : null
                                    }
                                    {/* SB lanes */}
                                    <div className='sb lanes-container'>
                                        {
                                            !props.readOnly &&
                                            <LanesButtons direction="sb" handleSetLane={handleSetLane} />
                                        }
                                        <label>{sbApproach}</label>
                                    </div>
                                    {/* intersection */}
                                    <div className='intersection-cnt'>
                                        {/* EB lanes */}
                                        <div className='eb lanes-container'>
                                            <label>{ebApproach}</label>
                                            {
                                                !props.readOnly &&
                                                <LanesButtons direction="eb" handleSetLane={handleSetLane} />
                                            }
                                        </div>
                                        {/* diagram */}
                                        <div className='image-cnt'>
                                            <div>
                                                <div className='corner-top-left'>
                                                    <Parking
                                                        handleSetParking={handleSetParking}
                                                        dir="sb"
                                                        checked={sbParking}
                                                        readOnly={props.readOnly}
                                                    />
                                                    {
                                                        typeControl === 'Signal' ?
                                                            <img src={require('../../assets/icons/lane_config/signal.svg')} />
                                                            :
                                                            typeControl === 'AWSC' || typeControl === 'TWSC-NS' ?
                                                                <img src={require('../../assets/icons/lane_config/stop_sign.svg')} />
                                                                : null

                                                    }
                                                </div>
                                                <div className='top-mid'>
                                                    {
                                                        typeControl === 'Signal' &&
                                                        <TurnPhasing
                                                            phasingList={phasingList}
                                                            handleSetPhasing={handleSetPhasing}
                                                            dir="sb"
                                                            ltSelected={sbLTPhasing}
                                                            rtSelected={sbRTPhasing}
                                                            collection={sbLanes}
                                                            readOnly={props.readOnly}
                                                        />
                                                    }
                                                    <div className='lane-img-cnt'>
                                                        {
                                                            sbLanes.map((item) => {
                                                                if (item > 0) {
                                                                    return <div className='remove-img-cnt' onClick={() => !props.readOnly ? removeFromLanes(item, 'sb') : null}>
                                                                        <img src={require('../../assets/icons/lane_config/' + item + '.svg')} />
                                                                        {!props.readOnly ? <img className='remove-lane' src={require('../../assets/icons/close.svg')} /> : null}
                                                                    </div>
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className='corner-top-right'>
                                                    <img className='directions' src={require('../../assets/icons/lane_config/directions.svg')} />
                                                    {
                                                        typeControl === 'Signal' ?
                                                            <img src={require('../../assets/icons/lane_config/signal.svg')} />
                                                            :
                                                            typeControl === 'AWSC' || typeControl === 'TWSC-EW' ?
                                                                <img src={require('../../assets/icons/lane_config/stop_sign.svg')} />
                                                                : null

                                                    }
                                                    <Parking
                                                        handleSetParking={handleSetParking}
                                                        dir="wb"
                                                        checked={wbParking}
                                                        readOnly={props.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div className='mid-left'>
                                                    {
                                                        typeControl === 'Signal' &&
                                                        <TurnPhasing
                                                            phasingList={phasingList}
                                                            handleSetPhasing={handleSetPhasing}
                                                            dir="eb"
                                                            ltSelected={ebLTPhasing}
                                                            rtSelected={ebRTPhasing}
                                                            collection={ebLanes}
                                                            readOnly={props.readOnly}
                                                        />
                                                    }
                                                    <div className='lane-img-cnt'>
                                                        {
                                                            ebLanes.map((item) => {
                                                                if (item > 0) {
                                                                    return <div className='remove-img-cnt' onClick={() => !props.readOnly ? removeFromLanes(item, 'eb') : null}>
                                                                        {!props.readOnly ? <img className='remove-lane' src={require('../../assets/icons/close.svg')} /> : null}
                                                                        <img src={require('../../assets/icons/lane_config/' + item + '.svg')} />
                                                                    </div>
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className='mid'>
                                                    {
                                                        maxLanes &&
                                                        <label>7 lanes max</label>
                                                    }
                                                    {
                                                        lanesConflict &&
                                                        <div>
                                                            <label>Conflicting movements</label>
                                                            <p>Please revise your selection</p>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='mid-right'>
                                                    <div className='lane-img-cnt'>
                                                        {
                                                            wbLanes.map((item) => {
                                                                if (item > 0) {

                                                                    return <div className='remove-img-cnt' onClick={() => !props.readOnly ? removeFromLanes(item, 'wb') : null}>
                                                                        {!props.readOnly ? <img className='remove-lane' src={require('../../assets/icons/close.svg')} /> : null}
                                                                        <img src={require('../../assets/icons/lane_config/' + item + '.svg')} />
                                                                    </div>
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        typeControl === 'Signal' &&
                                                        <TurnPhasing
                                                            phasingList={phasingList}
                                                            handleSetPhasing={handleSetPhasing}
                                                            dir="wb"
                                                            ltSelected={wbLTPhasing}
                                                            rtSelected={wbRTPhasing}
                                                            collection={wbLanes}
                                                            readOnly={props.readOnly}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                            <div>
                                                <div className='corner-bottom-left'>
                                                    <Parking
                                                        handleSetParking={handleSetParking}
                                                        dir="eb"
                                                        checked={ebParking}
                                                        readOnly={props.readOnly}
                                                    />
                                                    {
                                                        typeControl === 'Signal' ?
                                                            <img src={require('../../assets/icons/lane_config/signal.svg')} />
                                                            :
                                                            typeControl === 'AWSC' || typeControl === 'TWSC-EW' ?
                                                                <img src={require('../../assets/icons/lane_config/stop_sign.svg')} />
                                                                : null

                                                    }
                                                </div>
                                                <div className='bottom-mid'>
                                                    <div className='lane-img-cnt'>
                                                        {
                                                            nbLanes.map((item) => {
                                                                if (item > 0) {
                                                                    return <div className='remove-img-cnt' onClick={() => !props.readOnly ? removeFromLanes(item, 'nb') : null}>
                                                                        {!props.readOnly ? <img className='remove-lane' src={require('../../assets/icons/close.svg')} /> : null}
                                                                        <img src={require('../../assets/icons/lane_config/' + item + '.svg')} />
                                                                    </div>
                                                                }
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        typeControl === 'Signal' &&
                                                        <TurnPhasing
                                                            phasingList={phasingList}
                                                            handleSetPhasing={handleSetPhasing}
                                                            dir="nb"
                                                            ltSelected={nbLTPhasing}
                                                            rtSelected={nbRTPhasing}
                                                            collection={nbLanes}
                                                            readOnly={props.readOnly}
                                                        />
                                                    }
                                                </div>
                                                <div className='corner-bottom-right'>
                                                    {
                                                        typeControl === 'Signal' ?
                                                            <img src={require('../../assets/icons/lane_config/signal.svg')} />
                                                            :
                                                            typeControl === 'AWSC' || typeControl === 'TWSC-NS' ?
                                                                <img src={require('../../assets/icons/lane_config/stop_sign.svg')} />
                                                                : null

                                                    }
                                                    <Parking
                                                        handleSetParking={handleSetParking}
                                                        dir="nb"
                                                        checked={nbParking}
                                                        readOnly={props.readOnly}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* WB lanes */}
                                        <div className='wb lanes-container' >
                                            <label>{wbApproach}</label>
                                            {
                                                !props.readOnly &&
                                                <LanesButtons direction="wb" handleSetLane={handleSetLane} />
                                            }
                                        </div>
                                    </div>
                                    {/* NB lanes */}
                                    <div className='nb lanes-container'>
                                        <label>{nbApproach}</label>
                                        {
                                            !props.readOnly &&
                                            <LanesButtons direction="nb" handleSetLane={handleSetLane} />
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                !props.readOnly ?
                                    <div className='buttons-cnt'>
                                        <Button className='cancel-btn' onClick={handleClearLaneConfig}>Clear</Button>
                                        <Button className='blue-btn' /* onClick={handleSaveLaneConfig} */ onClick={handleCheckLaneConfig}>Save</Button>
                                    </div>
                                    :
                                    <div className='buttons-cnt'>
                                        <Button className='blue-btn' onClick={()=>props.setShowLaneConfig(false)}>Close</Button>
                                    </div>
                            }
                        </TabPanel>
                    </SwipeableViews>                    
                </Container>
            </div>
        </Modal>
            <Dialog
                open={showWarningLaneGeometryEdit}
                onClose={()=>{console.log()}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className='modal-container-lg-edit'
            >
                <div className="lg-flex">
                    <img src={require('../../assets/icons/lane_config/warning-modal.svg')}/>
                    <div >
                        <DialogTitle id="alert-dialog-title" className='modal-container-lg-title'>{"Edit station lane geometry"}</DialogTitle>
                        <DialogContent className='modal-container-lg-description'>
                            <DialogContentText id="alert-dialog-description" >
                                Are you sure you want to edit this? Changes to station lane geometry will apply to all subsequent HCM scenarios created for the station.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={()=>{handleEditLaneGeometry(false)}} className='lg-btn cancel'>
                                Cancel
                            </Button>
                            <Button onClick={()=>{handleEditLaneGeometry(true)}} className='lg-btn continue'>
                                Continue
                            </Button>
                        </DialogActions>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default LaneGeometry;